'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactMinimalistPortal = require('react-minimalist-portal');

var _reactMinimalistPortal2 = _interopRequireDefault(_reactMinimalistPortal);

var _reactTransitionGroup = require('react-transition-group');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactJss = require('react-jss');

var _reactJss2 = _interopRequireDefault(_reactJss);

var _noScroll = require('no-scroll');

var _noScroll2 = _interopRequireDefault(_noScroll);

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Modal = function (_Component) {
  _inherits(Modal, _Component);

  function Modal(props) {
    _classCallCheck(this, Modal);

    var _this = _possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).call(this, props));

    _this.handleKeydown = _this.handleKeydown.bind(_this);
    _this.onClickOverlay = _this.onClickOverlay.bind(_this);
    _this.onClickCloseIcon = _this.onClickCloseIcon.bind(_this);
    _this.state = {
      showPortal: props.open,
      open: props.open
    };
    return _this;
  }

  _createClass(Modal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.closeOnEsc) {
        document.addEventListener('keydown', this.handleKeydown);
      }
      // Block scroll when initial prop is open
      if (this.props.open) {
        this.blockScroll();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (!this.props.open && nextProps.open) {
        this.setState({
          open: true,
          showPortal: true
        }, function () {
          _this2.blockScroll();
        });
      }
      if (this.props.open && !nextProps.open) {
        this.setState({ open: false });
        // Let the animation finish
        this.timeout = setTimeout(function () {
          _this2.setState({ showPortal: false });
          _this2.unblockScroll();
        }, 500);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.closeOnEsc) {
        document.removeEventListener('keydown', this.handleKeydown);
      }
      this.unblockScroll();
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
    }
  }, {
    key: 'onClickOverlay',
    value: function onClickOverlay(e) {
      var _props = this.props,
          classes = _props.classes,
          closeOnOverlayClick = _props.closeOnOverlayClick;

      if (!closeOnOverlayClick || typeof e.target.className !== 'string') {
        return;
      }
      var className = e.target.className.split(' ');
      if (className.indexOf(classes.overlay) !== -1) {
        e.stopPropagation();
        this.props.onClose();
      }
    }
  }, {
    key: 'onClickCloseIcon',
    value: function onClickCloseIcon(e) {
      e.stopPropagation();
      this.props.onClose();
    }
  }, {
    key: 'handleKeydown',
    value: function handleKeydown(e) {
      if (e.keyCode === 27) {
        this.props.onClose();
      }
    }

    // eslint-disable-next-line class-methods-use-this

  }, {
    key: 'blockScroll',
    value: function blockScroll() {
      _noScroll2.default.on();
    }
  }, {
    key: 'unblockScroll',
    value: function unblockScroll() {
      var openedModals = document.getElementsByClassName(this.props.classes.modal);
      if (openedModals.length === 0) {
        _noScroll2.default.off();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          little = _props2.little,
          classes = _props2.classes,
          overlayClassName = _props2.overlayClassName,
          modalClassName = _props2.modalClassName,
          closeIconClassName = _props2.closeIconClassName,
          overlayStyle = _props2.overlayStyle,
          modalStyle = _props2.modalStyle,
          showCloseIcon = _props2.showCloseIcon,
          closeIconSize = _props2.closeIconSize;
      var _state = this.state,
          open = _state.open,
          showPortal = _state.showPortal;

      if (!showPortal) return null;
      return _react2.default.createElement(
        _reactMinimalistPortal2.default,
        null,
        _react2.default.createElement(
          _reactTransitionGroup.CSSTransitionGroup,
          {
            transitionName: {
              appear: classes.transitionEnter,
              appearActive: classes.transitionEnterActive,
              enter: classes.transitionEnter,
              enterActive: classes.transitionEnterActive,
              leave: classes.transitionLeave,
              leaveActive: classes.transitionLeaveActive
            },
            transitionAppear: true,
            transitionLeave: true,
            transitionAppearTimeout: 500,
            transitionEnterTimeout: 500,
            transitionLeaveTimeout: 500
          },
          open && _react2.default.createElement(
            'div',
            {
              className: (0, _classnames2.default)(classes.overlay, little ? classes.overlayLittle : null, overlayClassName),
              onMouseDown: this.onClickOverlay,
              style: overlayStyle
            },
            _react2.default.createElement(
              'div',
              {
                className: (0, _classnames2.default)(classes.modal, modalClassName),
                style: modalStyle
              },
              showCloseIcon ? _react2.default.createElement(
                'svg',
                {
                  className: (0, _classnames2.default)(classes.closeIcon, closeIconClassName),
                  onClick: this.onClickCloseIcon,
                  xmlns: 'http://www.w3.org/2000/svg',
                  width: closeIconSize,
                  height: closeIconSize,
                  viewBox: '0 0 36 36'
                },
                _react2.default.createElement('path', { d: 'M28.5 9.62L26.38 7.5 18 15.88 9.62 7.5 7.5 9.62 15.88 18 7.5 26.38l2.12 2.12L18 20.12l8.38 8.38 2.12-2.12L20.12 18z' })
              ) : null,
              this.props.children
            )
          )
        )
      );
    }
  }]);

  return Modal;
}(_react.Component);

Modal.propTypes = {
  closeOnEsc: _propTypes2.default.bool,
  closeOnOverlayClick: _propTypes2.default.bool,
  onClose: _propTypes2.default.func.isRequired,
  open: _propTypes2.default.bool.isRequired,
  overlayClassName: _propTypes2.default.string,
  modalClassName: _propTypes2.default.string,
  closeIconClassName: _propTypes2.default.string,
  overlayStyle: _propTypes2.default.object,
  modalStyle: _propTypes2.default.object,
  children: _propTypes2.default.node,
  classes: _propTypes2.default.object.isRequired,
  little: _propTypes2.default.bool,
  showCloseIcon: _propTypes2.default.bool,
  closeIconSize: _propTypes2.default.number
};

Modal.defaultProps = {
  closeOnEsc: true,
  closeOnOverlayClick: true,
  showCloseIcon: true,
  closeIconSize: 28,
  overlayClassName: null,
  modalClassName: null,
  closeIconClassName: null,
  overlayStyle: null,
  modalStyle: null,
  children: null,
  little: false
};

exports.default = (0, _reactJss2.default)(_styles2.default)(Modal);


//////////////////
// WEBPACK FOOTER
// ./~/react-responsive-modal/lib/modal.js
// module id = 638
// module chunks = 0